import { ThemeConfig } from './types'
import { typography, breakpoints, components } from './base.theme'

export const oceanTheme: ThemeConfig = {
  id: 'ocean',
  name: 'Ocean',
  description: 'Cool blue ocean theme',
  preview: {
    primaryColor: '#0277bd',
    secondaryColor: '#00acc1',
  },
  light: {
    palette: {
      mode: 'light',
      primary: {
        main: '#0277bd', // Ocean blue
        light: '#58a5f0',
        dark: '#004c8c',
        contrastText: '#ffffff',
      },
      secondary: {
        main: '#00acc1', // Cyan
        light: '#5ddef4',
        dark: '#007c91',
        contrastText: '#000000',
      },
      background: {
        default: '#e1f5fe',
        paper: '#ffffff',
      },
    },
    typography,
    breakpoints,
    components,
  },
  dark: {
    palette: {
      mode: 'dark',
      primary: {
        main: '#29b6f6',
        light: '#73e8ff',
        dark: '#0086c3',
        contrastText: '#000000',
      },
      secondary: {
        main: '#26c6da',
        light: '#6ff9ff',
        dark: '#0095a8',
        contrastText: '#000000',
      },
      background: {
        default: '#0d1b2a',
        paper: '#1b263b',
      },
    },
    typography,
    breakpoints,
    components,
  },
}
